<template>
    <div v-if="actions.length" class="col-4 pull-right mt-1 custom-actions">
        <b-row no-gutters>
            <b-col sm="10">
                <b-form-select :options="options" size="sm" v-model="value"/>
            </b-col>
            <b-col sm="1">
                <b-button variant="primary" size="sm" class="custom-actions-btn" @click="submit">
                    <i class="nav-icon icon-control-play"></i>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import {download} from "../api";

export default {
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        endpoint: {
            type: String,
            default: () => null,
            required: true,
        }
    },

    data() {
        return {
            value: null,
        }
    },

    computed: {
        options() {
            let options = this.actions.map((action) => {
                return {
                    value: action.name,
                    text: action.label,
                }
            });

            options.unshift({
                value: null,
                text: '-- Selecteer een actie',
            });

            return options;
        }
    },

    methods: {
        async submit() {

            if (this.value === null) {
                return;
            }

            const namespace = this.endpoint;

            const filtersJson = localStorage.getItem(`${namespace}-filters`);
            const filters = filtersJson ? JSON.parse(filtersJson) : [];

            let params = {
                action: this.value,
            };

            filters.forEach(filter => {
                params[filter.name] = filter.value;
            });

            const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

            switch (this.actions.find(x => x.name === this.value).type) {
                case 'download':
                    await download(`${this.endpoint}?${queryString}`);
                    return;
                case 'response':
                    this.showResponse(`${this.endpoint}?${queryString}`);
                    return;
            }
        },
    }
}
</script>